import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { usePanoramaMethodLogger } from '@wix/cli-panorama';
import { CodestoreClient } from './codestore-client.js';

export function useCodestoreClient(): CodestoreClient {
  const httpClient = useHttpClient({ type: 'backoffice' });
  const client = useMemo(() => new CodestoreClient(httpClient), [httpClient]);

  return usePanoramaMethodLogger(client);
}
